import React, { useEffect } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { motion } from "framer-motion";
import { CheckCircle2, Mail, Package } from "lucide-react";
import PlantImage from "../../components/fancyplants/PlantImage";
import Seo from "../../components/fancyplants/Seo";
import { SITE_IMAGES } from "../../data/siteImages";

export default function OrderConfirmedPage() {
  const [params] = useSearchParams();
  const ref = params.get("ref") || "FP-XXXXXX";
  const email = params.get("email") || "your email";
  const detail = params.get("detail") || "";

  useEffect(() => window.scrollTo(0, 0), []);

  return (
    <div className="pt-24">
      <Seo title="Order confirmed" noindex />
      <div className="container-fp flex flex-col items-center py-20 text-center">
        <div className="mb-8 w-full max-w-2xl overflow-hidden rounded-3xl">
          <PlantImage
            src={SITE_IMAGES.packing}
            alt="A plant delivery box prepared for shipping"
            ratio="16/9"
            priority
          />
        </div>
        <motion.span
          initial={{ scale: 0 }}
          animate={{ scale: 1 }}
          transition={{ type: "spring", stiffness: 260, damping: 16 }}
          className="mb-6 flex h-20 w-20 items-center justify-center rounded-full bg-forest-100 text-forest-700"
        >
          <CheckCircle2 size={40} />
        </motion.span>
        <p className="eyebrow mb-2">Request received</p>
        <h1 className="t-h1 max-w-xl">Thanks — we've got your request.</h1>
        <p className="t-lead mt-4 max-w-lg">
          Request <strong className="text-ink">{ref}</strong>. We'll email you to confirm what's
          available and arrange payment or collection — then pack with care and photograph exactly
          what's going in the box.
        </p>

        <div className="mt-8 grid w-full max-w-md gap-3 text-left">
          <div className="surface flex items-center gap-3 p-4">
            <Mail size={20} className="text-forest-700" />
            <span className="text-sm">We'll be in touch at <strong>{email}</strong> to confirm.</span>
          </div>
          {detail && (
            <div className="surface flex items-center gap-3 p-4">
              <Package size={20} className="text-forest-700" />
              <span className="text-sm">{detail}</span>
            </div>
          )}
        </div>

        <div className="mt-8 flex gap-3">
          <Link to="/shop" className="btn-forest">Keep browsing</Link>
          <Link to="/care" className="btn-outline">Read up on care</Link>
        </div>
        <p className="mt-6 max-w-md text-sm text-ink-soft">
          Once we confirm, you can create an account to track your order and leave a verified
          review when it arrives — no pressure.
        </p>
      </div>
    </div>
  );
}
